<template>
  <div class="header">
    <div class="container">
      <div class="logodiv">
        <a href="/" :title="$t('layout2.PublicLayoutHeader.259589-0')">{{ $t('layout2.PublicLayoutHeader.259589-1') }}</a>
      </div>
      <div class="hnav">
        <ul>
          <li>
            {{ xxx }}
            <a href="/">{{ $t('layout2.PublicLayoutHeader.259589-2') }}</a>
          </li>
          <li>
            <a href="/notice/bid-notice">{{ $t('layout2.PublicLayoutHeader.259589-3') }}</a>
          </li>
          <li>
            <a href="/notice/bid-winning-notice">{{ $t('layout2.PublicLayoutHeader.259589-4') }}</a>
          </li>
          <li>
            <a href="/service-center/index" class="pending">{{ $t('layout2.PublicLayoutHeader.259589-5') }}</a>
          </li>
          <li>
            <a href="https://www.haid.com.cn/" target="_blank">{{ $t('layout2.PublicLayoutHeader.259589-12') }}</a>
          </li>
        </ul>
      </div>

      <div class="logindiv" v-show="userInfo == null || userInfo.id == null">
        <a class="btnreg" id="register" href="/register/index">{{ $t('layout2.PublicLayoutHeader.259589-6') }}</a>
        <a class="btnlogin login" href="/login">{{ $t('layout2.PublicLayoutHeader.259589-7') }}</a>
      </div>
      <UserSetting></UserSetting>
      <!-- 国际化切换按钮 -->
      <div class="international-btn">
        <!-- 语言 -->
        <el-dropdown @command="switchLanguage">
          <span class="el-dropdown-link">
            <span>{{ $t('layout2.PublicLayoutHeader.259589-8') }}</span>
            <i class="el-icon-s-tools"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="language in languageOptions"
              :key="language.value"
              :command="language.value"
            >
              {{ language.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 时区 -->
        <!-- <el-dropdown @command="switchTimeZone">
          <span class="el-dropdown-link">
            时区<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="zone in timeZoneOptions"
              :key="zone.value"
              :command="zone.value"
            >
              {{ zone.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { getDictList } from '@/api';
import { updateOs } from '@/api/system';
import { DictListData } from '@/utils';

import ResizeMixin from "@/framework/layout/mixin/ResizeHandler";
import UserSetting from "@/framework/layout2/UserSetting.vue";

export default {
  name: "PublicLayoutHeader",
  components: { UserSetting },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      noticeNumber: (state) => state.app.noticeNumber,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
      userId: (state) => state.user.userId,
      userName: (state) => state.user.userName,
    }),
    ...mapGetters(['lang', 'timeZone']),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("user")),
      languageOptions: [], // 国际化语言配置列表
      timeZoneOptions: [],  // 时区配置列表
    };
  },
  computed: {
    xxx() {
      // console.log(1111);
      return this.$store.state.page.xx;
    },
    // 语言选项表
    // langOptions() {
    //   return [
    //     { value: 'zh', label: this.$t('layout2.PublicLayoutHeader.259589-9') },
    //     { value: 'en', label: this.$t('layout2.PublicLayoutHeader.259589-10') },
    //     { value: 'vi', label: this.$t('layout2.PublicLayoutHeader.259589-11') }
    //   ]
    // }
  },
  watch: {
    xxx(ne) {
      // console.log(ne);
    },
  },
  mounted() {
    // console.log(this.userInfo);
    this.getLanguageOptions()
  },
  methods: {
    logout() {},

    // 获取国际化语言配置
    async getLanguageOptions() {
      const { data } = await getDictList({ codelist: ['LanguageEnum', 'timeZone'] })
      // 语言
      this.languageOptions = DictListData(data, 'LanguageEnum')
      // 时区
      this.timeZoneOptions = DictListData(data, 'timeZone')
    },

    // 切换语言
    async switchLanguage(lang) {
      const user = JSON.parse(localStorage.getItem("user"))
      if(!user) {
        this.$store.commit("app/SET_LANG", lang)
        this.$i18n.locale = lang
        window.location.reload()
        return
      }
      const { code, message } = await updateOs({
        id: user.id,
        osLanguage: lang || 'chinese',
        osTimeZone: this.timeZone || 'GTM+8'
      })
      if (code === 200) {
        this.$store.commit("app/SET_LANG", lang)
        this.$i18n.locale = lang
        window.location.reload()
      } else {
        this.$message.error(message)
      }
    },

    // 切换时区
    async switchTimeZone(timeZone) {
      const { code, message } = await updateOs({
        id: this.userId,
        osLanguage: this.lang || 'chinese',
        osTimeZone: timeZone
      })
      if (code === 200) {
        this.$store.commit("app/SET_TIME_ZONE", timeZone)
        window.location.reload()
      } else {
        this.$message.error(message)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/framework/styles/mixin.scss";
@import "~@/config/styles/variables.scss";
@import "~@/config/styles/index.scss";
@import "~@/config/styles/bootstrap.scss";
@import "~@/config/styles/global.scss";
@import "~@/config/styles/kendo.default-v2.min.scss";

.container {
  display: flex;
  justify-content: space-between;
  .logodiv {
    margin-right: 0
  }
  .hnav {
    flex: 1
  }
  .logindiv {
    display: flex;
    > a {
      flex-shrink: 0;
      &:not(:last-child) {
        margin-right: 5px
      }
    }
  }
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }

  .hamburger-container {
    line-height: $tabsHeight;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    border-width: 0px;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
  .app-main-scroll-container {
    height: calc(100vh - #{$tabsHeight} - #{$headerHeight});
    width: 100%;
    .scrollbar {
      height: 100%;
      .scrollbar-wrapper {
        overflow-x: hidden;
      }
    }
  }
  .footer {
    height: $footerHeight;
    background: $footerBackgroundColor;
    color: $footerFontColor;
    font-size: $footerFontSize;
    text-align: $footerAlign;
    width: 100%;
    line-height: $footerHeight;
    border-top: 1px solid $footerBorderColor;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}

.header {
  position: relative;

  .international-btn {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translate(0, -50%);
  }
}
</style>
